import React from 'react';
import Sidebar from './Sidebar';

export default function Layout({ title, children, actions }) {
  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="topbar">
          <span className="topbar-title">{title}</span>
          <div className="topbar-right">{actions}</div>
        </div>
        <div className="page-body fade-in">{children}</div>
      </div>
    </div>
  );
}
